{#if currentSection}
	<h2>{currentSection.name}</h2>
	<div class=actionLine>
    <h3>Abschnitt schließen</h3>
    <button class=stopBtn onclick={() => game.close_scene(false)}>
      schließen
    </button>
	</div>
{:else}
	<h2>Sitzungen</h2>
	<SessionsTable />
{/if}

<div style="position: relative;">
	<h3>Spiel beenden</h3>
	<button class=endBtn onclick={terminate_game}>
    beenden
	</button>
</div>

{#if currentSection}
	<hr />
	<label for=plot>Handlung:</label>
	<textarea id='plot' value={currentSection?.plot} onchange={change_plot} disabled></textarea>
{/if}

<br>
<h2>Verfügbare Abschnitte</h2>
<table id=sectionTable>
    <thead>
		<tr>
				<th>Typ</th>
				<th>Name</th>
				<th>Aktion</th>
		</tr>
    </thead>
    <tbody>
	  {#each sections as section}
        <tr>
            <td>{section.type}</td>
            <td>{section.name}</td>
		        <td>
							{#if section.type === 'Scene'}
				        <button onclick={switch_section.bind(section)} style="width: 100%;">starten</button>
							{/if}
		        </td>
        </tr>
	  {/each}
    </tbody>
</table>



<script>
    import {user, game, view, send_data, send_request} from "../client.svelte.js";
    import SessionsTable from "../prepare/SessionsTable.svelte";

    let currentSection = $derived(user.sections.get(game.section) ?? null)
    let sections = $derived(view.adventure.sections.map(sectID => user.sections.get(sectID)))

    // $inspect(`SCENES-PANEL: currentSection`, currentSection)

	function terminate_game() {
		send_request('control', {command: 'TERMINATE'}, "Terminate game")
	}

    function switch_section() {
        game.switch(this.ID)
	}

    async function add_scene() {
        const sceneData = await create_scene()
        if (view.tale)
            game.switch(sceneData.ID)
	}

    function change_plot(e) {
        console.log(`SCENESPANEL: Change notes in scene ${currentSection.ID} to: `,  e.target.value)
        send_data('/scene', {ID: currentSection.ID, plot: e.target.value}, 'PATCH')
	}

</script>


<style lang="sass">
	@use "../colors" as colors

	.actionLine
    position: relative
    display: inline-block

	.stopBtn
    background-color: yellow
    position: absolute
    left: 320px
    top: 0

	.endBtn
    background-color: red
    position: absolute
    left: 320px
    top: 0

	label
    color: colors.$white

	textarea
    height: 60%
    width: 400px
    resize: vertical
    border: darkgrey 1px solid
    background-color: black
    color: colors.$white

	#sectionTable button
    background-color: darkgrey

</style>